var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-status"},[_c('span',{staticClass:"round-dot",style:({background: _vm.color || _vm.statusColor})}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }